module.exports = __webpack_public_path__ + "static/media/NEW-FONDOS_8.0f89cdc7.svg";